import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";
import {v4 as uuidv4} from 'uuid';

import { FONT } from "../../../value/staticValues";
import { ERROR_CODE } from "../../../value/type";
import { PLATFORM_URL } from "../../../value/Url";
import { base64Encoding, getCurrentTimestamp, getTimestampToDate } from "../../../common/util";
import { requests } from "../../../common/RestAPI";
import { ValidationError } from "../../../common/ExceptionError";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { CustomSquareCheckBox } from "../../base/CustomCheckBox";

interface ArgsType {
    volumeId: string,
    volumeName: string,
}

interface VolumeSnapshotAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

VolumeSnapshotAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function VolumeSnapshotAdd(props:VolumeSnapshotAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    const [volumeSnapshotName, setVolumeSnapshotName] = useState("");

    const [volumeSnapshotNameWarnYn, setVolumeSnapshotNameWarnYn] = useState(false);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkVolumeSnapshotData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, "");
                }
            }
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeAddYn) {
            executeAdd();
        }
    }, [executeAddYn]);


    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }


    function checkVolumeSnapshotData() {
        setVolumeSnapshotNameWarnYn(false);
        let message = "";
        let error = false;
        if(!volumeSnapshotName) {
            t("MESSAGE_VOLUME_SNAPSHOT_BASE_INFO_ENTER_ERROR_MESSAGE")
            setVolumeSnapshotNameWarnYn(true);
            error = true;
        }
        if(error == true)
            if(props.showMessageCb){
                props.showMessageCb(message);
        }
        return !error;
    }


    function executeAdd() {
        const body = {
            volume: {
                volume_id: props.args?.volumeId
            },
            volume_snapshot: {
                volume_snapshot_name: volumeSnapshotName
            },
            force_yn: false
        };

        requests.post(PLATFORM_URL.VOLUME + '/' + props.args?.volumeId + '/volumesnapshots', body)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VOLUME_SNAPSHOT_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        })
        .catch((error) => {
            if(error.status === 400) {
                if(error.data && error.data.detail.indexOf("in-use") >= 0) {
                    executeResult({successYn: false}, false, t("MESSAGE_VOLUME_SNAPSHOT_ADD_STATUS_ERROR_MESSAGE"));
                } else {
                    executeResult({successYn: false}, false, t("VM_VOLUME_INVALID_VOLUME"));
                }
            }
            if (error.status == 400) {
                
            }
            else if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VOLUME_SNAPSHOT_ADD_DUPLICATED_ERROR_MESSAGE"));
            }
            else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("MESSAGE_VOLUME_SNAPSHOT_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("SNAPSHOT_NAME_TEXT")}
                            </Text>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={volumeSnapshotName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setVolumeSnapshotName}
                                warnYn={volumeSnapshotNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    statusImg: {
        marginRight: 3
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    }
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}